import { idb } from "../db/index.ts";
import type { UpdateEvents } from "../../../common/types.ts";
import { getExistingLeagueCreationTypes } from "../../leagueCreationLimits.ts";

const updateDashboard = async (inputs: unknown, updateEvents: UpdateEvents) => {
	if (updateEvents.includes("firstRun") || updateEvents.includes("leagues")) {
		const leagues = await idb.meta.getAll("leagues");

		for (const league of leagues) {
			league.teamRegion ??= "???";
			league.teamName ??= "???";
		}

		const ownedLeagueCreationTypes = getExistingLeagueCreationTypes(leagues);

		return {
			leagues,
			ownedLeagueCreationTypes,
		};
	}
};

export default updateDashboard;
